import { NavLink, Navigate, useParams } from "react-router-dom"
import { Bell, Bot, CreditCard, KeyRound, UserRound } from "lucide-react"
import { cx } from "../../components/ui"
import { ProfileSettings } from "./ProfileSettings"
import { SecuritySettings } from "./SecuritySettings"
import { NotificationSettings } from "./NotificationSettings"
import { BillingSettings } from "./BillingSettings"
import { ApiTokenSettings } from "./ApiTokenSettings"

const SECTIONS = [
	{ key: "profile", label: "Profile", icon: UserRound, element: <ProfileSettings /> },
	{ key: "security", label: "Security", icon: KeyRound, element: <SecuritySettings /> },
	{
		key: "notifications",
		label: "Notifications",
		icon: Bell,
		element: <NotificationSettings />
	},
	{ key: "api-tokens", label: "API tokens", icon: Bot, element: <ApiTokenSettings /> },
	{ key: "billing", label: "Plan and billing", icon: CreditCard, element: <BillingSettings /> }
]

export function SettingsPage() {
	const { section } = useParams()
	const active = SECTIONS.find((entry) => entry.key === section)

	if (!active) return <Navigate to="/settings/profile" replace />

	return (
		<div className="space-y-5">
			<header>
				<h1 className="text-xl font-semibold tracking-tight text-ink-900">Settings</h1>
			</header>

			<div className="grid gap-6 lg:grid-cols-[13rem,1fr]">
				<nav className="flex gap-1 overflow-x-auto lg:flex-col lg:overflow-visible">
					{SECTIONS.map((entry) => (
						<NavLink
							key={entry.key}
							to={`/settings/${entry.key}`}
							className={({ isActive }) =>
								cx(
									"flex shrink-0 items-center gap-2.5 rounded-lg px-3 py-2 text-[0.8125rem] font-medium transition-colors",
									isActive
										? "bg-white text-ink-900 shadow-card"
										: "text-ink-600 hover:bg-white/70 hover:text-ink-900"
								)
							}
						>
							<entry.icon size={15} className="shrink-0" aria-hidden />
							{entry.label}
						</NavLink>
					))}
				</nav>

				<div className="min-w-0">{active.element}</div>
			</div>
		</div>
	)
}
